import Pako from 'pako';
export async function gzipToBase64(obj) {
    const compressed = Pako.deflate(JSON.stringify(obj));
    const reader = new FileReader();
    const readOnLoad = new Promise((resolve, reject) => {
        reader.onload = async () => {
            const url = String(reader.result);
            const base64 = url.slice(url.lastIndexOf(',') + 1);
            resolve(base64);
        };
        reader.onerror = (e) => {
            reject(e);
        };
    });
    reader.readAsDataURL(new Blob([compressed], { type: 'application/octet-binary' }));
    return await readOnLoad;
}
export async function gunzipFromBase64(base64OrDataUrl) {
    let dataUrl = base64OrDataUrl;
    if (!/^data:.+base64,/.test(dataUrl)) {
        dataUrl = `data:application/octet-stream;base64,${dataUrl}`;
    }
    return await fetch(dataUrl)
        .then(r => r.arrayBuffer())
        .then(r => Pako.inflate(r, { to: 'string' }))
        .then(r => JSON.parse(r));
}
